import script from "./PictureLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PictureLoader.vue?vue&type=script&setup=true&lang=js"

export default script